import { saveAs } from 'file-saver';
import FileExport from './FileExport';
import { FileType } from './FileType';

export default class FileUtility {
	public static downloadExcel = (report: FileExport) => {
		report.type = FileType.EXCEL;
		FileUtility.download(report);
	};

	public static downloadPdf = (report: FileExport) => {
		report.type = FileType.PDF;
		FileUtility.download(report);
	};

	public static download = (report: FileExport) => {
		const arrayBuffer = FileUtility.base64ToArrayBuffer(report.content);
		FileUtility.save(arrayBuffer, report.caption, FileUtility.getFileType(report.type));
	};

	private static save(file: any, filename: string, type: string) {
		var blob = new Blob([file], { type: type });
		var name = `${filename}`;
		saveAs(blob, name);
	}

	private static base64ToArrayBuffer(base64: any) {
		var binaryString = window.atob(base64);
		var binaryLen = binaryString.length;
		var bytes = new Uint8Array(binaryLen);
		
		for (var i = 0; i < binaryLen; i++) {
			var ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}

		return bytes;
	}

	private static getFileType(type?: FileType): string {
		switch (type) {
			case FileType.EXCEL: return 'application/vnd.ms-excel.sheet.macroenabled.12';
			case FileType.PDF: return 'application/pdf';
			default: return '';
		}
	}
}
